import { render, staticRenderFns } from "./city.vue?vue&type=template&id=ca1c56d8&"
import script from "./city.vue?vue&type=script&lang=js&"
export * from "./city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports